export default __webpack_public_path__ + "static/media/gratefloor.b6c1ae8e.png";